var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCalendarIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.38462 6.51923C4.01739 6.51923 3.66521 6.6651 3.40554 6.92477C3.14588 7.18444 3 7.53662 3 7.90384V20.3654C3 20.7326 3.14588 21.0848 3.40554 21.3445C3.66521 21.6041 4.01739 21.75 4.38462 21.75H19.6154C19.9826 21.75 20.3348 21.6041 20.5945 21.3445C20.8541 21.0848 21 20.7326 21 20.3654V7.90384C21 7.53662 20.8541 7.18444 20.5945 6.92477C20.3348 6.6651 19.9826 6.51923 19.6154 6.51923H16.8462",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.0577H21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15381 3.75V9.28846",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8462 3.75V9.28846",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15381 6.51923H14.0769",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendarIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CalendarIcon.981f3389.svg";
export { ForwardRef as ReactComponent };